import { useMutation } from '@tanstack/react-query';

import { JWT_STORAGE_KEY } from 'src/utils/constants';

import { orderClient, paymentClient } from 'src/lib/api';

/**
 * Initialize STC Payment for Extra Charges
 * @returns
 */
export const useInitSTCPay_ExtraCharges = () => {
  const token = sessionStorage.getItem(JWT_STORAGE_KEY);
  const mutationFn = (payload) =>
    paymentClient
      .post('api/v1/payments/payment/EC/extraChargeUsingSTC', payload, {
        headers: {
          token,
        },
      })
      .then((res) => res.data);
  return useMutation({
    mutationFn,
    mutationKey: ['payment_useInitSTCPay_ExtraCharges'],
  });
};
/**
 * Initialize STC Payment for PAD
 * @returns
 */
export const useInitSTCPay_PAD = () => {
  const token = sessionStorage.getItem(JWT_STORAGE_KEY);
  const mutationFn = (payload) =>
    paymentClient
      .post('api/v1/payments/payment/PAD/padUsingSTC', payload, {
        headers: {
          token,
        },
      })
      .then((res) => res.data);
  return useMutation({
    mutationFn,
    mutationKey: ['payment_useInitSTCPay_PAD'],
  });
};

/**
 * Initialize STC + Wallet Payment for Extra Charges
 * @returns
 */
export const useInitSTCPayPlusWallet_ExtraCharges = () => {
  const token = sessionStorage.getItem(JWT_STORAGE_KEY);
  const mutationFn = (payload) =>
    paymentClient
      .post('api/v1/payments/payment/EC/extraChargeUsingSTCAndWallet', payload, {
        headers: {
          token,
        },
      })
      .then((res) => res.data);
  return useMutation({
    mutationFn,
    mutationKey: ['payment_useInitSTCPayPlusWallet_ExtraCharges'],
  });
};

/**
 * Initialize STC + Wallet Payment for PAD
 * @returns
 */
export const useInitSTCPayPlusWallet_PAD = () => {
  const token = sessionStorage.getItem(JWT_STORAGE_KEY);
  const mutationFn = (payload) =>
    paymentClient
      .post('api/v1/payments/payment/PAD/padUsingSTCAndWallet', payload, {
        headers: {
          token,
        },
      })
      .then((res) => res.data);
  return useMutation({
    mutationFn,
    mutationKey: ['payment_useInitSTCPayPlusWallet_PAD'],
  });
};

/**
 * Initialize STC  Payment for Order
 * @returns
 */
export const useInitSTCPay_Order = () => {
  const token = sessionStorage.getItem(JWT_STORAGE_KEY);
  const mutationFn = (payload) =>
    orderClient
      .post('api/v1/order/stcPayRequestForOrderPlacement', payload, {
        headers: {
          token,
        },
      })
      .then((res) => res.data);
  return useMutation({
    mutationFn,
    mutationKey: ['payment_useInitSTCPay_Order'],
  });
};

/**
 * Verify STC Payment for Extra Charges
 * @returns
 */
export const useVerifySTCPay_ExtraCharges = () => {
  const token = sessionStorage.getItem(JWT_STORAGE_KEY);
  const mutationFn = (payload) =>
    paymentClient
      .post('api/v1/payments/payment/EC/extraChargeUsingSTCConfirmation', payload, {
        headers: {
          token,
        },
      })
      .then((res) => res.data);
  return useMutation({
    mutationFn,
    mutationKey: ['payment_useVerifySTCPay_ExtraCharges'],
  });
};

/**
 * Verify STC Payment for PAD
 * @returns
 */
export const useVerifySTCPay_PAD = () => {
  const token = sessionStorage.getItem(JWT_STORAGE_KEY);
  const mutationFn = (payload) =>
    paymentClient
      .post('api/v1/payments/payment/PAD/padUsingSTCConfirmation', payload, {
        headers: {
          token,
        },
      })
      .then((res) => res.data);
  return useMutation({
    mutationFn,
    mutationKey: ['payment_useVerifySTCPay_PAD'],
  });
};

/**
 * Verify STC + Wallet Payment for Extra Charges
 * @returns
 */
export const useVerifySTCPlusWalletPay_ExtraCharges = () => {
  const token = sessionStorage.getItem(JWT_STORAGE_KEY);
  const mutationFn = (payload) =>
    paymentClient
      .post('api/v1/payments/payment/EC/extraChargeUsingSTCAndWalletConfirmation', payload, {
        headers: {
          token,
        },
      })
      .then((res) => res.data);
  return useMutation({
    mutationFn,
    mutationKey: ['payment_useVerifySTCPlusWalletPay_ExtraCharges'],
  });
};

/**
 * Verify STC + Wallet Payment for PAD
 * @returns
 */
export const useVerifySTCPlusWalletPay_PAD = () => {
  const token = sessionStorage.getItem(JWT_STORAGE_KEY);
  const mutationFn = (payload) =>
    paymentClient
      .post('api/v1/payments/payment/PAD/padUsingSTCAndWalletConfirmation', payload, {
        headers: {
          token,
        },
      })
      .then((res) => res.data);
  return useMutation({
    mutationFn,
    mutationKey: ['payment_useVerifySTCPlusWalletPay_PAD'],
  });
};
